import { Injectable } from '@angular/core';

import { OkModalComponent } from '../components/modals/ok-modal/ok-modal.component';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class ModalInfoService {
  constructor(private modalService: ModalService) {}

  infoSmall(header: string, message: string) {
    const { modal, component } = this.modalService.openSmall<OkModalComponent>(OkModalComponent);
    component.header = header;
    component.message = message;
    modal.result.then(
      () => {},
      () => {},
    );
  }
}
